import * as React from 'react'

// Components
import Svg from './..'

const GreenMoneyBag = props => {
  return (
    <Svg width='1em' height='1em' viewBox='0 0 11 13' fill='none' {...props}>
      <path
        d='M6.276 8.636a.618.618 0 00-.174-.126 2.093 2.093 0 00-.439-.156v1.163c.244-.027.523-.116.651-.343a.531.531 0 00.048-.363.365.365 0 00-.086-.175zM6.313 9.178l.002-.004-.002.004zM4.52 6.777a.49.49 0 00-.05.43.362.362 0 00.14.155c.065.044.137.079.21.108.06.024.13.048.203.07V6.489c-.187.04-.39.125-.503.289zM6.32 9.165l-.006.012.007-.012zM6.325 9.156c.001-.003.001-.003 0 0z'
        fill='#3CE967'
      />
      <path
        d='M6.072 2.829c.99-.831 1.65-2.703 1.244-2.785-.54-.108-1.714.369-2.281.453-.805.097-1.68-.872-2.172-.332-.4.44.286 2.037 1.36 2.733-3.204 1.575-7.708 9.48.15 10.055 10.871.793 5.427-8.59 1.7-10.124zm.934 6.235a1.143 1.143 0 01-.44.776c-.259.2-.582.293-.903.319v.34c0 .091-.04.18-.108.24a.322.322 0 01-.346.05.322.322 0 01-.186-.29v-.372a2.131 2.131 0 01-.164-.038 1.57 1.57 0 01-.782-.481 1.41 1.41 0 01-.28-.514c-.011-.036-.022-.072-.026-.108a.32.32 0 01.622-.133c.012.037.02.074.034.11a.815.815 0 00.19.285c.112.11.256.18.406.222V8.205c-.293-.076-.596-.174-.838-.362a.976.976 0 01-.283-.34 1.064 1.064 0 01-.1-.458 1.09 1.09 0 01.36-.824c.235-.217.547-.337.861-.382V5.486c0-.091.04-.18.108-.24a.322.322 0 01.346-.051.323.323 0 01.186.29V5.838c.042.005.083.012.125.02.308.055.61.182.835.404a1.22 1.22 0 01.33.599.32.32 0 01-.614.162c-.014-.035-.02-.072-.034-.107a.61.61 0 00-.203-.26 1.037 1.037 0 00-.44-.17v1.21c.185.044.37.092.547.162.267.105.52.267.667.522a1.926 1.926 0 010 .001c.045.079.024.041.001.002.116.205.154.45.13.682z'
        fill='#3CE967'
      />
      <path d='M6.31 9.182l-.006.012.007-.012z' fill='#3CE967' />
    </Svg>
  )
}

export default GreenMoneyBag
